function configureInstitutionDropDown(dropDown: HTMLSelectElement) {
  dropDown.addEventListener('change', () => {
    dropDown.form?.submit()
  })
}

function configureDownloadInvoiceButton(button: HTMLButtonElement) {
  const invoicesUrl = button.dataset.invoicesUrl
  const invoiceBaseUrl = button.dataset.invoiceBaseUrl
  if (!invoicesUrl || !invoiceBaseUrl) return

  button.addEventListener('click', async () => {
    button.disabled = true

    try {
      const response = await fetch(invoicesUrl, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      })
      if (!response.ok) {
        console.error(
          `Failed to fetch invoices: ${response.status} ${response.statusText}`,
        )
        alert(
          `Could not download invoice (server returned ${response.status}). Please try again.`,
        )
        return
      }
      const data = (await response.json()) as {
        invoices: { id: string; invoicenumber?: string }[]
        institution_id: number
      }

      const buildUrl = (settlementId: string) =>
        `${invoiceBaseUrl.replace('SETTLEMENT_ID', settlementId)}?institution=${data.institution_id}`

      if (data.invoices.length === 1) {
        window.location.href = buildUrl(data.invoices[0].id)
      } else if (data.invoices.length > 1) {
        // Multiple invoices — open each in a new tab
        for (const invoice of data.invoices) {
          window.open(buildUrl(invoice.id))
        }
      }
    } finally {
      button.disabled = false
    }
  })
}

function initCommissionsList() {
  const institutionDropDown = document.getElementById(
    'id_institution',
  ) as HTMLSelectElement
  configureInstitutionDropDown(institutionDropDown)

  document
    .querySelectorAll<HTMLButtonElement>('.commission-run-invoices__download')
    .forEach(configureDownloadInvoiceButton)
}

export { initCommissionsList }
